module.exports = __webpack_public_path__ + "static/media/Grandmother---Charcoal.28fbe134.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Grandmother---Charcoal.jpg
 ** module id = 441
 ** module chunks = 0
 **/